import { Injectable, inject } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap, catchError, finalize } from "rxjs/operators";
import { LokiMonitoringService, IProcessingTimeMetric } from "../core/services/outros/loki-monitoring.service";


@Injectable()
export class MonitoringInterceptor implements HttpInterceptor {
  private monitoringService = inject(LokiMonitoringService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startTime = Date.now();
    const url = req.url;
    const method = req.method;
    const endpointWithoutQuery = url.split("?")[0];

    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;
          const statusCode = event.status;

          const processingMetric: IProcessingTimeMetric = {
            operation: `${method} ${this.getEndpointName(url)}`,
            duration,
            endpoint: endpointWithoutQuery,
            success: statusCode >= 200 && statusCode < 300,
          };

          this.monitoringService.logProcessingTime(processingMetric);
        }
      }),

      catchError((error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;

        const processingMetric: IProcessingTimeMetric = {
          operation: `${method} ${this.getEndpointName(url)}`,
          duration,
          endpoint: endpointWithoutQuery,
          success: false,
        };

        this.monitoringService.logProcessingTime(processingMetric);

        return throwError(() => error);
      }),
      finalize(() => { })
    );
  }

  private getEndpointName(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split("/").filter((p) => p);
      return pathParts[pathParts.length - 1] || "unknown";
    } catch {
      const parts = url.split("/").filter((p) => p);
      return parts[parts.length - 1]?.split("?")[0] || "unknown";
    }
  }
}
